module.exports = __webpack_public_path__ + "static/img/winter_banner.985bef0d.jpg";